var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18.667,
    viewBox: "0 0 14 18.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3203",
    "data-name": "Group 3203",
    transform: "translate(-573 -436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3196",
    "data-name": "Group 3196",
    transform: "translate(0 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M15.25,20.667H4.75A1.752,1.752,0,0,1,3,18.917V10.75A1.752,1.752,0,0,1,4.75,9h10.5A1.752,1.752,0,0,1,17,10.75v8.167A1.752,1.752,0,0,1,15.25,20.667Zm-10.5-10.5a.584.584,0,0,0-.583.583v8.167a.584.584,0,0,0,.583.583h10.5a.584.584,0,0,0,.583-.583V10.75a.584.584,0,0,0-.583-.583Z",
    transform: "translate(570 469)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M14.75,8.167a.584.584,0,0,1-.583-.583V4.667a3.5,3.5,0,1,0-7,0V7.583A.583.583,0,1,1,6,7.583V4.667a4.667,4.667,0,1,1,9.333,0V7.583A.584.584,0,0,1,14.75,8.167Z",
    transform: "translate(569.333 471)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M11.556,16.111a1.556,1.556,0,1,1,1.556-1.556A1.557,1.557,0,0,1,11.556,16.111Zm0-1.944a.389.389,0,1,0,.389.389A.39.39,0,0,0,11.556,14.167Z",
    transform: "translate(568.444 468.111)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M11.833,19.056a.584.584,0,0,1-.583-.583V16.333a.583.583,0,1,1,1.167,0v2.139A.584.584,0,0,1,11.833,19.056Z",
    transform: "translate(568.167 467.5)",
    fill: "#b7b7b7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.79c04edc.svg";
export { ForwardRef as ReactComponent };